import React from "react";
import ImageWithPlaceholder from "../../Common/ImageWithPlaceholder";
const ParticipantAvatar = (props) => {
    const renderContent = () => {
        if (props.type === "user") {
            return (React.createElement("div", { className: "position-relative" },
                React.createElement("a", { role: "button", 
                    //@ts-ignore
                    rel: "tooltip", href: `/user/index/${props.id}`, title: `Go to ${props.firstName}'s profile` },
                    React.createElement(ImageWithPlaceholder, { className: "leaderboard-participant-avatar secondary-border", src: "/" + props.image })),
                React.createElement("img", { className: "leaderboard-participant-avatar avatar-country", src: `/public/images/flags/square/${props.countryCode}.png`, alt: "" })));
        }
        return (React.createElement(ImageWithPlaceholder, { src: "/" + props.image, className: "leaderboard-participant-teamavatar", type: "mission" }));
    };
    return React.createElement("div", { className: "me-2 me-sm-4" }, renderContent());
};
export default React.memo(ParticipantAvatar);
